<template>
    <div class="filter-item filter-item--checkbox filter-item--checklist" v-if="checkBoxList.length">
        <h2 class="filter-item__heading" v-text="title"></h2>
        <div class="filter-item__checklist">
            <checkbox v-for="(checkbox, checkboxKey) in checkBoxList" :name="checkbox.name" :value="checkbox.active" @checked="(checked) => selectKeyword(checked, checkboxKey)" :key="checkbox.keyword.code"></checkbox>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import Checkbox from '../checkbox.vue';
import { trackEvent } from '../../tracker';

export default {
    props: {
        keywordCode: {type: Array, default: null},
        title: {type: String, default: ''},
        checkboxName: {type: Array, default: null},
        radio: {type: Boolean, default: false}
    },
    data() {
        return {
            activeKeywords: [ ]
        }
    },
    mounted() {
        this.updateKeywordList();
    },
    watch: {
        '$route.query.keywords'() {
            this.updateKeywordList();
        },
        activeKeywords(newVal) {
            if(_.isEmpty(newVal)) {
                newVal = null;
            }

            let query = Object.assign({}, this.$route.query);
            query.keywords = (newVal) ? JSON.stringify(newVal) : newVal;
            this.$router.replace({query}, (to, from, next) => {
                let value = this.checkBoxList.filter(({active}) => active);

                trackEvent({
                    event: 'Filter - ' + this.title,
                    target: to.fullPath,
                    value,
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction',
                })
            });
        }
    },
    methods: {
        updateKeywordList() {
            try {
                this.activeKeywords = (this.$route.query.keywords) ? JSON.parse(this.$route.query.keywords) : [ ];
            } catch(e) {
                
            }
        },
        selectKeyword(checked, keyWordIdx) {
            let keywordCode = this.keywordCode[keyWordIdx];
            let key = this.activeKeywords.indexOf(keywordCode);
            if(checked && key <= -1) {
                this.activeKeywords.push(keywordCode);
            } else if(!checked && key > -1) {
                this.activeKeywords.splice(key, 1);
            }

            if(this.radio && checked) {
                for(let i in this.activeCheckboxlist) {
                    if(this.activeCheckboxlist[i]) {
                        let removeKeyWordCode = this.activeCheckboxlist[i].keyword.code;
                        if(removeKeyWordCode !== keywordCode) {
                            let removeKey = this.activeKeywords.indexOf(removeKeyWordCode);
                            if(removeKey > -1 ) { 
                                this.activeKeywords.splice(removeKey, 1);
                            }
                        }
                    }
                }
            }
        }
    },
    computed: {
        checkBoxList() {
            if(!this.keywordCode)
                return [ ];
            
            let keyWords = this.$store.state.filters.keywords || [ ];
            return this.keywordCode.map((keywordCode, key) => {
                let keyword = keyWords.filter((keyword) => keyword.code == keywordCode);
                if(!keyword.length) {
                    return null;
                }
                
                keyword = keyword[0];
                let name = (this.checkboxName) ? this.checkboxName[key] : null;
                if(!name && keyword.name) {
                    name = keyword.name
                } else if(!name) {
                    name = '';
                }

                return {
                    active: (this.activeKeywords.indexOf(keywordCode) > -1) ? true : false,
                    keyword,
                    name
                }
            }).filter((item) => item);
        },
        activeCheckboxlist() {
            return this.checkBoxList.filter((item) => item.active);
        }
    },
    components: {
        Checkbox
    }
}
</script>
